import { render, staticRenderFns } from "./DevAllotArch.vue?vue&type=template&id=79776f62&scoped=true"
import script from "./DevAllotArch.vue?vue&type=script&lang=js"
export * from "./DevAllotArch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79776f62",
  null
  
)

export default component.exports